import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import './DiningSantaCatarina.css';

const DiningSantaCatarina: React.FC = () => {
  useEffect(() => {
    // Initialize horizontal scroll for the carousel
    const cleanup = initializeDragScroll('dining-carousel');
    return cleanup;
  }, []);

  const diningPanels = [
    {
      id: 'restaurant',
      image: images.santaCatarinaRestaurant || images.restaurantFeature,
      title: 'Our Restaurants',
      content: 'Enjoy meals where fresh ingredients and fresh takes. Dine at one of our acclaimed restaurants — Beach, Bateiras and Veleza — where ingredients are often sourced directly from our garden.'
    },
    {
      id: 'cuisine',
      image: images.santaCatarinaDining2 || images.foodImage,
      title: 'Classic Meets Contemporary: The Essence of Brazilian Gastronomy',
      content: 'Join us for a culinary journey through Brazil, where traditional flavors blend with contemporary flair. Discover a menu that celebrates Brazil\'s rich gastronomic culture, designed to satisfy every palate.'
    },
    {
      id: 'chef',
      image: images.chefSantaCatarina || images.teamMember2,
      title: 'Daniela Damasceno - Awasi Santa Catarina Chef',
      content: 'Born in Cascavel, Paraná, Dani graduated in gastronomy and started at Ponta dos Ganchos as a kitchen assistant. A decade later, she became chef at the hotel. She lived in France, where she worked at the starred Les Prés d\'Eugénie, by chef Michel Guérard, in addition to studying in San Sebastián, Spain, and in the Bologna region, Italy.'
    },
    {
      id: 'ingredients',
      image: images.santaCatarinaDining3 || images.foodImage,
      title: 'Savor every bit of Brazilian flavours',
      content: 'Our fine dining options cater to every taste and occasion. Explore dining events that range from beachside dinners to meals at scenic spots. Each offers a fresh approach to enjoying the local flavors and settings.'
    }
  ];

  return (
    <div className="dining-page">
      <UnifiedNavigation variant="light" destination="santa-catarina" />
      
      {/* Horizontal Carousel Section */}
      <section className="dining-carousel-section" data-scroll-section="dining">
        <div 
          id="dining-carousel"
          className="dining-carousel"
        >
          {diningPanels.map((panel, index) => (
            <div key={panel.id} className="dining-panel">
              <div className="dining-panel__image">
                <img src={panel.image} alt={panel.title} />
              </div>
              <div className="dining-panel__content">
                <h2 className="dining-panel__title">{panel.title}</h2>
                <p className="dining-panel__text">{panel.content}</p>
                <button className="dining-panel__cta">CONTACT US</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <InstagramSection />
      <Footer variant="santa-catarina" />
    </div>
  );
};

export default DiningSantaCatarina;